import React from 'react';
import {
    BooleanField,
    BooleanInput,
    Datagrid,
    DateField,
    EditButton,
    Filter,
    List,
    ShowButton,
    TextField,
    TextInput
} from 'react-admin';

const CityFilter = (props) => (
        <Filter {...props}>
            <TextInput label="city code" source="code" alwaysOn/>
            <TextInput label="iata codes" source="iata" alwaysOn/>
            <TextInput label="name" source="name" alwaysOn/>
            <TextInput label="country code" source="countryIsoAlpha2" alwaysOn/>
            <BooleanInput label="is capital" source="capital"/>
            <BooleanInput label="activated" source="active" alwaysOn/>
        </Filter>
);

const CityList = props => (
        <List {...props}
              perPage={25}
              filters={<CityFilter/>}
              filterDefaultValues={{active: true}}
              title="Tripset API Manager - Cities">
            <Datagrid>
                <TextField source="code"/>
                <TextField source="iata"/>
                <TextField source="name"/>
                <TextField source="countryIsoAlpha2"/>
                <BooleanField source="capital"/>
                <BooleanField source="active"/>
                <DateField source="updatedAt" showTime/>
                <EditButton/>
                <ShowButton/>
            </Datagrid>
        </List>
);

export default CityList;
